export const buttonSuccess = {
    text: 'Iniciar',
    type: 'success',
    useSubmitBehavior: true,
    icon: 'far fa-check-circle',
    disabled: false,
};

